































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Popup } from '@questelservices/common-vue';
import { DxColumn, DxDataGrid, DxPager, DxPaging, DxRemoteOperations, DxFilterRow, DxHeaderFilter, DxSelection, DxScrolling } from 'devextreme-vue/data-grid';
import { DxButton, DxCheckBox } from 'devextreme-vue';
import CustomStore from 'devextreme/data/custom_store';
import CommonModule, { QuestelServicesClient } from '@questelservices/common';
import { Prop } from 'vue-property-decorator';
import { AvailableMattersDto } from '../models/AvailableMattersDto';
import { ActivityPlannerService } from '../service/ActivityPlannerService';
import { getModule } from 'vuex-module-decorators';
import store from '../store';
import { MatterWorkTypeEnum } from '../models/matter-work/MatterWorkTypeEnum';
import DataGrid from 'devextreme/ui/data_grid';
import _ from 'lodash';

const commonState = getModule(CommonModule, store);

@Component({
    components: {
        DxDataGrid,
        DxCheckBox,
        DxPager,
        DxPaging,
        DxRemoteOperations,
        DxFilterRow,
        DxColumn,
        DxButton,
        DxHeaderFilter,
        DxSelection,
        DxScrolling,
        Popup
    }
})
export default class ActivityPlannerClaimDialog extends Vue {
    private showDialog: boolean = false;

    clientId: Guid = '';
    isClaimAll: boolean = false;
    matterWorkType: MatterWorkTypeEnum = MatterWorkTypeEnum.Coding;

    activityPlannerService: ActivityPlannerService;
    client: QuestelServicesClient;
    notes: string = '';
    claimError: string = '';

    get dataGrid() {
      return (this.$refs['claimTable'] as DxDataGrid).instance;
    }

    get claimWorkUrl(): string {
      return `/api/activityplanner/claim-dialog/${this.matterWorkType}`;
    }

    get title() {
        if (this.matterWorkType === MatterWorkTypeEnum.Coding) {
            return 'Claim matters for manual code assignment';
        } else if (this.matterWorkType === MatterWorkTypeEnum.Auditing) {
            return 'Claim matters for auditing work';
        }
    }

    @Watch('showDialog')
    onPropertyChanged(value: boolean, oldValue: boolean) {
        if (value) {
            this.claimError = '';
        }            
    }

    constructor() {
        super();
        this.activityPlannerService = new ActivityPlannerService('/api');
        this.client = new QuestelServicesClient(this.$store, '');
    }

    show() {
      this.showDialog = true;
    }

    close() {
      this.showDialog = false;
    }

    onShowing(e: any) {
      if (this.dataGrid) {
        this.dataGrid.option('dataSource', this.dataSource);
        this.dataGrid.refresh()
          .then(() => {
            if (this.dataGrid) {
              this.dataGrid.getScrollable().scrollTo(0);
            }
          });
        
        this.dataGrid.option('selectionFilter', this.isClaimAll ? null : []);
      }

      this.notes = this.isClaimAll ? 'All cases were claimed by ' + commonState.authenticatedUser.fullName : '';
    }

    onHidden(e: any) {
      if (this.dataGrid) {
        this.dataGrid.option('dataSource', []);
        this.dataGrid.option('selectionFilter', []);
      }

      this.notes = '';
    }

    get dataSource() {
        return new CustomStore({
            key: 'MatterId',
            load: loadOptions => {
                return this.client.postJson(this.claimWorkUrl + `?clientId=${this.clientId}`, loadOptions)
                    .then(result => {
                        if (!result.Data) {
                            throw result;
                        }
                        return result.Data;
                    })
                    .catch(result => {
                        if (result && result.Message) {
                            throw result.Message;
                        } else {
                            throw 'Error loading data.';
                        }
                    });
            }
        });
    }

    contentReady(e: any) {
        if (e.component.shouldSkipNextReady) {
            e.component.shouldSkipNextReady = false;
        } else {
            e.component.shouldSkipNextReady = true;
            e.component.columnOption('command:select', 'width', 40);
            e.component.updateDimensions();
        }
    }

    async claimSelectedWork() {
        if (!this.dataGrid) {
          return;
        }

        let selectedRowKeys = await this.dataGrid.getSelectedRowKeys();

        if (selectedRowKeys.length > 0) {
            this.activityPlannerService.claimWork({ mattersToClaim: selectedRowKeys, notes: this.notes }, this.matterWorkType)
                .then(result => {
                    if (this.matterWorkType === MatterWorkTypeEnum.Coding) {
                        this.$router.push(`/phase-assignment/${result.Data}`);
                    } else if (this.matterWorkType === MatterWorkTypeEnum.Auditing) {
                        let caseCount = _.uniq(selectedRowKeys).length;
                        this.$router.push(`/auditing/${result.Data}?cases=${caseCount}`);
                    } else {
                        this.close();
                    }
                });
        } else {
            this.claimError = 'Select at least one matter to claim.';
        }
    }
}
